<template>
  <div class="content_doctor">
    <div class="hospital hp_space_between">
      <div class="hp_flex">
        <div class="hospitalImg hp_center">
          <img v-if="doctor.image" :src="base_url + doctor.image" alt />
          <img v-else src="@/assets/default-img/doctor.png" alt />
        </div>
        <div class="detail">
          <div class="hp_cz_center">
            <span class="name">{{ doctor.name }}</span>
            <span class="job">{{ doctor.title }}</span>
            <a-rate disabled style="color:#FF9C00;" v-model="doctor.score" allow-half />
          </div>
          <div class="tags hp_cz_center">
            <span class="hopital">{{ doctor.deptName }}</span>
            <div v-if="doctor.important" class="tag">{{ getImportantName(doctor.important) }}</div>
          </div>
          <div class="tags hp_cz_center">
            <span class="hopital">{{ doctor.hospitalName }}</span>
            <span v-if="doctor.levelName" class="tag">
              {{
              doctor.levelName
              }}
            </span>
            <span v-if="doctor.adminLevelName" class="tag">
              {{
              doctor.adminLevelName
              }}
            </span>
            <template v-if="doctor.typeNames">
              <div
                v-for="(tag, index) in doctor.typeNames.split(',')"
                :key="index"
                class="tag"
              >{{ tag }}</div>
            </template>
          </div>
          <p style="width:100%;" class="mobile hp_cz_center">医生简介：{{ doctor.intro }}</p>
        </div>
      </div>
      <div @click="attention" class="attention hp_center">
        <icon-font :class="{ active: doctor.favorite }" type="icon-guanzhu1" />
        <span class="text-center-g">{{ doctor.favorite ? '已关注' : '关注' }}</span>
      </div>
    </div>
    <div class="depts">
      <div class="hp_flex days">
        <div
          :class="{ active: item.active }"
          class="hp_center day"
          v-for="(item, index) in timeDaysList"
          :key="index"
          @click="changeDay(index)"
        >
          {{ item.text }}
          <br />
          {{ item.dayTime }}
        </div>
      </div>
      <a-skeleton :loading="loading1" />
      <template v-if="!loading1">
        <template v-if="timeSolt && timeSolt.length > 0">
          <div v-for="(item, index) in timeSolt" :key="index" class="times">
            <div class="registration hp_flex">
              <div v-for="(time, timeIndex) in item.numberList" :key="timeIndex" class="time">
                <div class="time_left">{{ time.beginTime }}-{{ time.endTime }}</div>
                <a-button
                  :disabled="time.maxCount == time.orderCount"
                  class="btn"
                  @click="toPage(time, item)"
                >
                  <div>挂号</div>
                  <div style=" font-size: 16px;">余号:{{ time.maxCount - time.orderCount }}</div>
                </a-button>
              </div>
            </div>
          </div>
        </template>
        <noData v-else></noData>
      </template>
    </div>
    <div class="evaluate">
      <div class="title">
        患者评价
        <span v-if="totalCount">（{{ totalCount }}条）</span>
      </div>
      <template v-if="hospitalComment && hospitalComment.length > 0">
        <div class="evaluate_demo hp_flex" v-for="(item, index) in hospitalComment" :key="index">
          <img v-if="item.avatar" class="photo" :src="base_url + item.avatar" alt />
          <img v-else class="photo" src="@/assets/default-img/r-doctor.png" alt />
          <div class="demo_right">
            <a-row>
              <a-col :span="8">科室：{{ item.deptName }}</a-col>
              <a-col :span="8">就诊医生：{{ item.doctorName }}</a-col>
              <a-col :span="8">评论时间：{{ item.createTime }}</a-col>
            </a-row>
            <div class="hp_flex">
              <span>对医生的评价：</span>
              <a-rate disabled style="color:#FF9C00;" :default-value="item.star" allow-half />
              <div class="tags">
                <a-tag
                  v-for="(tag, tagIndex) in strSplit(
                    item.content,
                    doctorDict,
                    0
                  )"
                  :key="tagIndex"
                  color="#FF9C00"
                >{{ tag }}</a-tag>
              </div>
            </div>
            <div>{{ strSplit(item.content, doctorDict, 1) }}</div>
          </div>
        </div>
        <div style="margin-top: 20px;">
          <a-pagination
            show-quick-jumper
            :current="currPage"
            :total="totalCount"
            :defaultPageSize="commentForm.pageSize"
            @change="onChange"
          />
        </div>
      </template>
      <noData v-else></noData>
    </div>
  </div>
</template>
<script>
import {
  getDoctorDetail,
  cancelFavorite,
  submitFavorite,
  getScheduleList,
  getCommentDoctor,
  getDict,
} from "@/api/registered";
import { getHospitalDetail } from "@/api/payment";
import { ls } from "@/utils/tool";
import noData from "@/components/NoData";
export default {
  components: {
    noData,
  },
  data() {
    return {
      id: this.$route.params.id,
      doctor: {},
      timeDaysList: [],
      day: "",
      sysUser: ls.get("sysUser"),
      timeSolt: [],
      commentForm: {
        pageNum: 1,
        pageSize: 5,
        doctorId: this.$route.params.id,
      },
      hospitalComment: [],
      currPage: 1,
      totalCount: 1,
      doctorDict: [],
      loading1: true,
    };
  },
  watch: {
    $route() {
      this.id = this.$route.params.id;
      this.active = this.$route.params.active;
      this.commentForm.doctorId = this.$route.params.id;
      this.initDoctor();
      this.initTime();
      this.initComment();
      this.initDict();
    },
  },
  mounted() {
    this.initDoctor();
    this.initTime();
    this.initComment();
    this.initDict();
  },
  methods: {
    toPage(item, dayItem) {
      if (
        this.day == this.dayjs().format("YYYY-MM-DD") &&
        this.handSchFlg == 1
      ) {
        this.$message.warning("该医院不支持当天预约！");
        return;
      }
      console.log("item=====", item);
      let orderTime =
        this.day +
        " " +
        (item.beginTime || "08:45") +
        "-" +
        (item.endTime || "09:45");
      let hospitalName = this.doctor.hospitalName,
        deptName = this.doctor.deptName,
        doctorName = this.doctor.name,
        doctorId = this.doctor.id,
        hospitalId = this.doctor.hospitalId,
        schId = dayItem.scheduleId,
        srcId = item.hisId;

      this.$router.push({
        name: "sure-Information",
        query: {
          id: this.doctor.hospitalId,
          ...item,
          orderTime,
          hospitalName,
          deptName,
          doctorName,
          doctorId,
          hospitalId,
          schId,
          srcId,
          unitPrice: dayItem.unitPrice,
        },
      });
    },
    strSplit(str, dict, num) {
      var arr = str.split("|||");
      var content = "";
      arr = arr.filter((item) => {
        var save = dict.some((d) => {
          return d.text == item;
        });
        if (save) {
          return item;
        } else {
          content = item;
        }
      });
      return !num ? arr || [] : content;
    },
    async initDict() {
      var res = await getDict({
        type: "DOCTOR_IMPRESSION",
      });

      this.doctorDict = res.data;
    },
    async getScheduleList() {
      this.loading1 = true;
      console.log("this.id==", this.id);
      var params = {
        day: this.day,
        deptId: this.doctor.deptId,
        doctorId: this.id,
      };
      var res = await getScheduleList(params);
      console.log("res===", res);
      if (res.code !== 200) this.$message.error(res.message);
      this.timeSolt = res.data;
      this.loading1 = false;
    },
    async attention() {
      var data = {
        memberId: this.sysUser.id,
        objectId: this.id,
        objectType: 3,
      };
      var res;
      if (this.doctor.favorite) {
        res = await cancelFavorite(data);
      } else {
        res = await submitFavorite(data);
      }
      this.initDoctor();
    },
    initTime() {
      var arr = [];
      var weekArr = ["日", "一", "二", "三", "四", "五", "六"];
      for (let index = 0; index < 7; index++) {
        arr.push({
          text: index
            ? "周" + weekArr[this.dayjs().add(index, "day").day()]
            : "今天",
          dayTime: index ? this.dayjs().add(index, "day").format("MM/DD") : "",
          day: index
            ? this.dayjs().add(index, "day").format("YYYY-MM-DD")
            : this.dayjs().format("YYYY-MM-DD"),
          active: false,
        });
      }
      this.active = this.$route.params.active;
      arr[this.active].active = true;
      this.timeDaysList = arr;
      console.log(this.timeDaysList);
      this.day = arr[this.active].day;
      console.log("day", this.day);
    },
    changeDay(index) {
      this.timeDaysList = this.timeDaysList.map((item) => {
        item.active = false;
        return item;
      });
      this.timeDaysList[index].active = true;
      this.day = this.timeDaysList[index].day;
      this.getScheduleList();
    },
    async initDoctor() {
      var res = await getDoctorDetail(this.id);
      console.log("详情", res);
      if (res.code === 200) {
        this.doctor = res.data;
        this.getScheduleList();
        let rs = await getHospitalDetail(res.data.hospitalId);
        this.handSchFlg = rs.data.handSchFlg;
        console.log("医院信息", rs);
        return;
      }
      if (res.code == 208) {
        this.$message.error("暂无该医生数据");
      } else {
        if (res.code == 500) {
          this.$router.push({ path: "/login" });
        }
        this.$message.warning(res.message);
      }
      this.doctor = {};
    },
    async initComment() {
      var res = await getCommentDoctor(this.commentForm);
      console.log("res==", res);
      this.hospitalComment = res.data.list;
      this.totalCount = res.data.totalCount;
      this.currPage = res.data.currPage;
    },
    onChange(pageNumber) {
      this.commentForm.pageNum = pageNumber;
      this.initComment();
    },
  },
};
</script>
<style lang="less" scoped>
.content_doctor {
  width: 911px;
  box-shadow: 0px 0px 21px 0px rgba(154, 200, 255, 0.32);
  border-radius: 10px;
  padding: 25px 21px;
  .hospital {
    width: 100%;
    padding-bottom: 30px;
    border-bottom: solid 5px #f6f6f6;
    position: relative;
    .hospitalImg {
      width: 339px !important;
      height: 196px;
      margin-right: 26px;
      border-radius: 6px;
      overflow: hidden;
      img {
        height: 196px;
      }
    }
    .detail {
      width: calc(100% - 375px);
      .name {
        font-size: 28px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #333333;
        margin-right: 10px;
      }
      .job {
        font-size: 20px;
        font-weight: 400;
        color: #333333;
        margin-right: 10px;
      }
      .tags {
        width: 100%;
        flex-wrap: wrap;
        margin-top: 6px;
        margin-bottom: 15px;
        .hopital {
          font-size: 20px;
          font-weight: 400;
          color: #333333;
          margin-right: 18px;
        }
        .tag {
          border-radius: 10px;
          padding: 7px 12px;
          line-height: 1;
          font-size: 14px;
          color: #ffffff;
          background: #0079fe;
        }
        .tag:not(:last-child) {
          margin-right: 19px;
        }
      }
      .mobile {
        margin-top: 12px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        span {
          margin-left: 15px;
        }
      }
    }
    .attention {
      cursor: pointer;
      position: absolute;
      right: 0;
      top: 0;
      line-height: 1;
      border: 1px solid #dcdcdc;
      border-radius: 8px;
      padding: 8px 6px;
      height: 34px;
      /deep/ .anticon {
        margin-right: 6px;
        font-size: 16px;
        color: #999;
      }
      .active {
        color: #d81e06;
      }
    }
  }
  .depts {
    padding-bottom: 30px;
    border-bottom: solid 5px #f6f6f6;
    .days {
      margin-top: 10px;
      margin-bottom: 32px;
      border: 1px solid #dcdcdc;
      width: 707px;
      .day {
        cursor: pointer;
        font-size: 16px;
        color: #666666;
        line-height: 1;
        width: 102px;
        height: 48px;
        text-align: center;
      }
      .day:not(:last-child) {
        border-right: 1px solid #dcdcdc;
      }
      .active {
        background: #4694ff;
        color: #fff;
      }
    }
    .times {
      font-size: 22px;
      font-weight: bold;
      color: #0079fe;
      line-height: 1;
      display: flex;
      flex-wrap: wrap;
      margin-right: 47px;
      margin-bottom: 50px;
      .registration {
        flex-wrap: wrap;
        padding-left: 22px;
        padding-top: 22px;
        .time {
          width: 161px;
          margin-bottom: 10px;
          .time_left {
            width: 100%;
            text-align: center;
            font-size: 22px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #0079fe;
            margin-bottom: 20px;
          }

          .btn {
            cursor: pointer;
            width: 161px;
            height: 58px;
            background: #0079fe;
            border-radius: 6px;
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #ffffff;
            text-align: center;
          }
        }
      }
    }
  }
  .evaluate {
    .title {
      font-size: 26px;
      font-weight: bold;
      color: #333333;
      padding: 25px 0;
      span {
        font-size: 20px;
        color: #666666;
      }
    }
    .evaluate_demo {
      padding-bottom: 20px;
      .photo {
        border: 1px solid #0079fe;
        width: 62px;
        height: 62px;
        border-radius: 50%;
        margin-right: 20px;
      }
      .demo_right {
        color: #666666;
        font-size: 18px;
        width: calc(100% - 82px);
        .tags {
          margin-left: 20px;
        }
      }
    }
    .evaluate_demo:not(:last-child) {
      border-bottom: 2px solid #f6f6f6;
    }
    .evaluate_demo:not(:first-child) {
      padding-top: 20px;
    }
  }
}
</style>
